import { Injectable } from '@angular/core';
import { ActiveCartService, CartAdapter } from '@spartacus/cart/base/core';
import { RoutingService, WindowRef } from '@spartacus/core';
import { PageLayoutHandler } from '@spartacus/storefront';
import { combineLatest, map, Observable, of, switchMap } from 'rxjs';
import { catchError, filter, take } from 'rxjs/operators';
import { KnBrCommonService } from '../services/kn-br-common.service';
import { KnBrCartContextService } from '../store/kn-br-cart-context/kn-br-cart-context.service';

@Injectable({
  providedIn: 'root',
})
export class SalesCheckoutPageLayoutHandler implements PageLayoutHandler {
  constructor(
    private activeCartService: ActiveCartService,
    private cartAdapter: CartAdapter,
    private routingService: RoutingService,
    private windowRef: WindowRef,
    protected commonService: KnBrCommonService,
    private knBrCartContextService: KnBrCartContextService
  ) {}

  handle(slots$: Observable<string[]>, pageTemplate?: string, section?: string): Observable<string[]> {
    if (pageTemplate !== 'CarlisleSalesCheckoutSummaryPageTemplate' || section) {
      return slots$;
    }
    this.commonService.showSpinner$.next(true);

    const entries$ = this.knBrCartContextService.get$.pipe(
      switchMap((cartId) => {
        if (!cartId) {
          return of([]);
        }
        return this.cartAdapter.loadAll('current').pipe(
          map((carts) => {
            const firstCart = carts && carts.length ? carts[0] : null;
            return firstCart && Array.isArray(firstCart.entries) ? firstCart.entries : [];
          }),
          catchError(() => of([]))
        );
      })
    );

    return combineLatest([
      slots$,
      entries$,
      this.activeCartService.getLoading(),
    ]).pipe(
      filter(([, , loadingCart]) => !loadingCart),
      take(1),
      map(([slots, entries]) => {
        this.commonService.showSpinner$.next(false);
        if (!this.windowRef.isBrowser() || this.canProceedToCheckout(entries)) {
          return slots;
        }

        this.routingService.goByUrl('/salesCart');
        return [];
      })
    );
  }

  private canProceedToCheckout(entries: any[]): boolean {
    if (!entries.length) {
      return false;
    }

    return entries.every((entry) => {
      const maxOrderQuantity = entry.product?.maxOrderQuantity ?? entry.product?.maxOrderQty;
      const isOverLimit = maxOrderQuantity !== undefined && entry.quantity > maxOrderQuantity;

      return !isOverLimit || Boolean(entry.carlisleOverlimitComment?.trim());
    });
  }
}